import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";

export function useVendorArticlesList(articleId: string) {
	const query = useQuery({
		queryKey: ["vendor-articles", articleId],
		queryFn: async () => {
			const response = await client.stock.articles[":articleId"]["vendor-articles"].$get({
				param: { articleId },
			});
			const data = await responseHandler(response);
			return data.vendorArticles;
		},
	});

	return { ...query, vendorArticles: guardArray(query.data) };
}
